import { compact } from "lodash";
import { useMemo } from "react";

import { useFieldContext } from "./Field";

export const useInputAriaDescribedBy = () => {
  const { fieldErrorId, fieldHintId } = useFieldContext();

  return useMemo(() => {
    if (!fieldErrorId && !fieldHintId) return null;

    return compact([fieldErrorId, fieldHintId]).join(" ");
  }, [fieldErrorId, fieldHintId]);
};
